export { default as marriageToVeteran } from './marriageToVeteran';
export { default as marriageToVeteranLocation } from './marriageToVeteranLocation';
export { default as marriageToVeteranInfo } from './marriageToVeteranInfo';
export { default as legalStatusOfMarriage } from './legalStatusOfMarriage';
export { default as marriageToVeteranEnd } from './marriageToVeteranEnd';
export { default as marriageToVeteranEndInfo } from './marriageToVeteranEndInfo';
export { default as marriageToVeteranEndDeathInfo } from './marriageToVeteranEndDeathInfo';
export { default as marriageStatus } from './marriageStatus';
export { default as reasonForSeparation } from './reasonForSeparation';
export { default as separationDetails } from './separationDetails';
export { default as remarriage } from './remarriage';
export { default as veteranChildren } from './veteranChildren';
export { default as spouseMarriages } from './spouseMarriages';
export { veteranMarriagesPages } from './veteranMarriagesPages';
export { previousMarriagesPages } from './previousMarriagesPages';
export { default as dependentsCount } from './dependentsCount';
export { default as dependentBirthInformation } from './dependentBirthInformation';
export {
  default as dependentName,
  hasDependentChildToAdd,
} from './dependentName';
export {
  default as additionalDependents,
  needsAdditionalDependentsForm,
} from './additionalDependents';
export { default as dependentRelationship } from './dependentRelationship';
export { default as dependentInformation } from './dependentInformation';
